export default [
    {
        display: true,
        name: 'Western AI',
        site: 'https://www.westernuai.com/',
        img: 'img/organizations_logos/wai.png',
        description: 'In the 2019-2020 academic year, I had the opportunity to be a Project Manager for a project run through <a href="https://www.westernuai.com/" target="_blank">Western AI</a>. Western AI is "Western’s on-campus undergraduate AI community", their mission is to "mission is to educate students in important AI topics, centralize and develop AI talent, and launch AI-enabled careers in fields of interest."'
    },
    {
        display: true,
        name: 'Western Management Club',
        site: 'https://www.westernmanagementclub.com/',
        img: 'img/organizations_logos/wmc.png',
        description: 'In my second and third year at UWO I was a pro-bono consultant for the <a href="https://www.westernmanagementclub.com/" target="_blank">Western Management Club (WMC)</a>. I worked in a team to provide pro-bono consulting services for a local business in London, Ontario.'
    },

]